export interface DevelopmentPlanAccess {
  isAdmin: boolean;
  isDirector: boolean;
  /** per-store userAccess.leadership.developmentPlansDirectorOnly */
  developmentPlansDirectorOnly: boolean;
}

/**
 * Whether the user may access the leadership Development Plans page.
 * When the store flag is off, everyone keeps access. When on, only
 * Directors and admins do.
 */
export function canAccessDevelopmentPlans(a: DevelopmentPlanAccess): boolean {
  if (!a.developmentPlansDirectorOnly) return true;
  return a.isAdmin || a.isDirector;
}
